export const CLAIM_ANGPAU = "CLAIM_ANGPAU";
export const MOBILE_APPS_PROMO_CLAIM = "MOBILE_APPS_PROMO_CLAIM";
